export enum ErrorTypeEnum {
    ApolloError = 0,
    Error = 1,
    FrontEndError = 2,
    LoginError = 3
}
